import { colors } from '@hazadapt-git/public-core-base'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import { FC } from 'react'
import { makeStyles } from 'tss-react/mui'

interface LoadingOverlayProps {
    loading: boolean
    showOverlay?: boolean
}

export const LoadingOverlay: FC<LoadingOverlayProps> = (
    props: LoadingOverlayProps
) => {
    const { classes: localClasses } = useLocalStyles()

    return (
        <div
            className={localClasses.overlayContainer}
            style={props?.showOverlay ? { pointerEvents: 'none' } : undefined}
        >
            <div className={localClasses.overlayContent}>
                {props.loading && (
                    <CircularProgress size="1rem" color="primary" />
                )}
                <Typography fontWeight={500}>
                    {props.loading
                        ? 'Updating...'
                        : "Hold 'Control' and scroll to zoom"}
                </Typography>
            </div>
        </div>
    )
}

const useLocalStyles = makeStyles()({
    overlayContainer: {
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.25)',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        left: 0,
        position: 'absolute',
        top: 0,
        width: '100%',
        zIndex: 2,
    },
    overlayContent: {
        alignItems: 'center',
        backgroundColor: colors.grays.BLANC,
        borderRadius: '0.5rem',
        display: 'flex',
        gap: '1rem',
        justifyContent: 'center',
        padding: '1rem',
    },
})
